import React, { useContext } from 'react';
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '../../../../chart';
import { AppDataContext } from 'contexts/appData';
import moment from 'moment/moment';
import 'moment/locale/ka';
import 'moment/locale/ru';
import { useAnalyticsContext } from '../AnalyticsProvider';
import { calculateYAxisConfig } from '../helpers';

export const Chart = () => {
  const { getLang } = useContext(AppDataContext);
  const { chartData, activeTab, currentTotal } = useAnalyticsContext();
  const { langs } = useContext(AppDataContext);

  const yAxisConfig = calculateYAxisConfig(Math.max(...chartData.map((item) => item[activeTab])));
  const chartConfig = {
    displays: {
      label: langs?.NM_Displays,
    },
    views: {
      label: langs?.Views,
    },
    phone_views: {
      label: langs?.Calls,
    },
    favorites: {
      label: langs?.Favorites,
    },
    add_to_cart: {
      label: langs?.M_Cart,
    },
  };



  return (
    <div className="px-16px mt-48px">
      <ChartContainer config={chartConfig} className="w-100 max-height-340px">
        <ResponsiveContainer maxHeight={340} height="100%">
          <AreaChart data={chartData} width="100%" height="100%">
            <defs>
              <linearGradient id="defaultFill" x1="-2608.5" y1="0" x2="-2608.5" y2="294.273" gradientUnits="userSpaceOnUse">
                <stop offset="0.05" stopColor="#FFD102" stopOpacity="0.3" />
                <stop offset="0.95" stopColor="#FFD102" stopOpacity="0.05" />
              </linearGradient>
            </defs>
            <CartesianGrid vertical={false} stroke="#EEE" />
            <XAxis
              dataKey="date"
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              interval="preserveStartEnd"
              tickFormatter={(value) => {
                const date = new Date(value);
                return moment(date).locale(getLang).format('D MMM, YYYY');
              }}
            />
            <YAxis
              width="auto"
              allowDecimals={false}
              tickCount={6}
              ticks={yAxisConfig.ticks}
              domain={yAxisConfig.domain}
              dataKey={activeTab}
              tickLine={false}
              axisLine={false}
              tickSize={10}
              tickFormatter={(value) => {
                if (value >= 1000) return `${(value / 1000).toFixed(1)}k`;
                return value;
              }}
            />
            <ChartTooltip
              cursor={false}
              content={
                <ChartTooltipContent
                  className="w-150px"
                  nameKey={activeTab}
                  formatter={({ payload, value, item, label }) => {
                    return (
                      <div>
                        <div className="mb-4px text-primary-text" style={{ fontSize: 12 }}>
                          {moment(new Date(payload.date)).locale(getLang).format('D MMMM, YYYY')}
                        </div>

                        <div className="d-flex align-items-center gap-8px">
                          <div style={{ width: 8, height: 8, borderRadius: '4px', background: item.color }}></div>
                          <div className="text-gray-150">{label}</div>
                          <div className="font-medium">{value}</div>
                        </div>
                      </div>
                    );
                  }}
                  hideLabel
                  indicator="dot"
                />
              }
            />
            <Area dataKey={activeTab} type="monotone" fill="url(#defaultFill)" stroke="#CB9600" stackId="a" />
          </AreaChart>
        </ResponsiveContainer>
      </ChartContainer>
    </div>
  );
};
